<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false">

      <slide>
          <div class="padding">
          <p>I walked back from work this evening and the obelisk was lit up from inside. Like it was made of glass, or was on fire. The names on the side of it - you know the one I mean, by the river and the bombed out warehouses - they seemed to glow from inside it, each name lit up somehow and burning into the rain. I stopped and read some of them and they didn't seem familiar, like they weren't the names that were there yesterday. It was probably the light, a trick of the rain or some art stunt, but it spooked me.</p>

          <p>I thought about woman who live across from us. The one Oska thought was hiding someone in her apartment. She came out yesterday, into the hallway and then down into the street, without her coat on, and she has the most amazing tattoo across the back of her neck. It's a pair of circles, they intersect, I think, and there are smaller circles inside them and lines between all of them. I wanted to write this down because I'm sure it's the same design I found behind the wallpaper in Oska's room. When the water came in and I had to redecorate and that huge piece of plaster came away from the wall.</p>
           <p> &nbsp;</p>
          <p> &nbsp;</p>
          </div>
      </slide>

    </carousel>
  </div>
</template>

<script>
export default {

  name: '4',

  data () {
    return {
      title: 'Tattoos'
    }
  },
  mounted () {
    this.$emit('title-update', this.title)
  }
}
</script>

<style lang="css" scoped>
</style>
